import {
  createContext,
  PropsWithChildren,
  use,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

const ViewsCaptureFlashContext = createContext<ReturnType<
  typeof useProvider
> | null>(null);

export const useCaptureFlash = () => use(ViewsCaptureFlashContext);

export function ViewsCaptureFlashProvider({ children }: PropsWithChildren) {
  const value = useProvider();
  return (
    <ViewsCaptureFlashContext value={value}>
      {children}
    </ViewsCaptureFlashContext>
  );
}

function useProvider() {
  const [isFlashing, setFlashing] = useState(false);
  const flashTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (flashTimeoutRef.current) {
        clearTimeout(flashTimeoutRef.current);
      }
    };
  }, []);

  const triggerFlash = useCallback(() => {
    setFlashing(true);
    if (flashTimeoutRef.current) {
      clearTimeout(flashTimeoutRef.current);
    }

    flashTimeoutRef.current = setTimeout(() => {
      setFlashing(false);
      flashTimeoutRef.current = null;
    }, 400);
  }, []);

  return { isFlashing, triggerFlash };
}
